import { __assign, __extends } from "tslib";
import EventEmitter from '@antv/event-emitter';
var Guide = /** @class */ (function (_super) {
    __extends(Guide, _super);
    function Guide(cfg) {
        var _this = _super.call(this) || this;
        _this.cfg = __assign({ id: null, 
            // 容器
            canvas: null, container: null, group: null, 
            // 交互属性
            capture: true, 
            // props
            // coord: null,
            offsetX: 0, offsetY: 0, visible: true, zIndex: 1 }, cfg);
        _this.destroyed = false;
        return _this;
    }
    // 由于重构后影响太大了 所以使用any先
    Guide.prototype.get = function (name) {
        return this.cfg[name];
    };
    Guide.prototype.set = function (name, value) {
        this.cfg[name] = value;
        return this;
    };
    Guide.prototype.destroy = function () {
        this.off();
        this.destroyed = true;
    };
    return Guide;
}(EventEmitter));
export { Guide };
export default Guide;
//# sourceMappingURL=base.js.map